import React from 'react';
import {
  OverridableComponent,
} from '@mui/material/OverridableComponent';
import isNil from 'lodash/isNil';
import CashIcon from '@mui/icons-material/LocalAtmRounded';
import CardIcon from '@mui/icons-material/CreditCardRounded';
import CheckIcon from '@mui/icons-material/AutoStoriesRounded';
import BankIcon from '@mui/icons-material/AccountBalanceRounded';
import CreditIcon from '@mui/icons-material/PriceChangeRounded';
import NoneIcon from '@mui/icons-material/HelpOutlineRounded';
import Tag from 'core/components/Tag';
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import {
  paymentTypes,
} from 'pages/Dashboard/pages/Billing/Payments/utils';

type Props = {
  number: string;
  type?: typeof paymentTypes[number];
};

const iconsByType: Record<string, OverridableComponent<any>> = Object.freeze({
  cash: CashIcon,
  card: CardIcon,
  check: CheckIcon,
  ach: BankIcon,
  none: NoneIcon,
  manualcredittransfer: CreditIcon,
  manualcard: CardIcon,
  square: CardIcon,
  collectionagencycheck: RequestQuoteOutlinedIcon,
});

const tooltipsByType: Record<string, string> = {
  cash: 'Cash Payment',
  card: 'Card Payment',
  check: 'Check Payment',
  ach: 'ACH Payment',
  manualcredittransfer: 'Manual Credit Transfer',
  none: 'Unknown Payment',
  manualcard: 'Manual Card Refund',
  square: 'Square Refund',
  collectionagencycheck: 'Collection Agency Check Payment',
};

export default function PaymentCell({
  number,
  type: discriminator,
}: Props) {
  const type = (discriminator ?? 'CashPayment').replace('Payment', '').replace('Refund', '').toLowerCase();
  const Icon = iconsByType[type] ?? iconsByType.CashIcon;

  return (
    <Tag
      tagName="terminal"
      className="w-fit !p-0 !text-gray-500"
      tooltip={tooltipsByType[type] ?? undefined}
    >
      <div className="flex items-center gap-1 font-semibold text-inherit">
        {!isNil(Icon) && (
          <Icon className="!w-4 !h-4 !text-inherit" />
        )}
        <span>
          #
          {number}
        </span>
      </div>
    </Tag>
  );
}
